import { render, staticRenderFns } from "./CommNav.vue?vue&type=template&id=42250dcf&scoped=true"
import script from "./CommNav.vue?vue&type=script&lang=js"
export * from "./CommNav.vue?vue&type=script&lang=js"
import style0 from "./CommNav.vue?vue&type=style&index=0&id=42250dcf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42250dcf",
  null
  
)

export default component.exports